import React from 'react';

// styles
import styles from "./ShareToConsultant.module.css"

const ConsultantsList = (props) => {
    // console.log(props.consultantsList)
    // console.log(props.selectedConsultants)

    const handleClick = (id) => {
        const itemSelected = props.consultantsList.filter((item) => id === item.id);
        const found = props.selectedConsultants.find(item => item.id == itemSelected[0].id)
        // console.log(itemSelected)

        if (found === undefined) {
            props.setSelectedConsultants([...props.selectedConsultants, itemSelected[0]]);
        }
        props.setShowLists(false)
    };
    return (
        <>
            <div className={`d-flex flex-column align-items-start justify-content-start mt-2 py-2 px-4 ${styles.lists_container}`} >
                {props.consultantsList?.map((item) => (
                    <div key={item.id} className={`my-2 w-100 ${styles.list_item}`} onClick={() => handleClick(item.id)}>
                        {`${item.name} ${item.family}`}
                    </div>
                ))}
            </div>
        </>
    );
};

export default ConsultantsList;